import { Box, CardMedia, IconButton, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { formatSeconds } from "@/utils";

const getIsodate = (datetime) => {
  return new Date(datetime * 1000).toISOString().split("T")[0];
};

const getDaysOnNotebook = (row) => {
  const now = Date.now() / 1000;
  const end = Math.min(now, ...[row.expires, row.deleted].filter(Boolean));
  return Math.max(0, Math.floor((end - row.live) / (24 * 60 * 60)));
};

export const getColumns = (onEdit, desktop = true) => [
  {
    field: "edit",
    headerName: "",
    renderCell: ({ row }) => (
      <IconButton size="small" onClick={() => onEdit(row)}>
        <Edit color="info" fontSize="small" />
      </IconButton>
    ),
    width: 44,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: "title",
    headerName: "Title",
    minWidth: desktop ? 240 : 160,
    // flex: desktop ? 0 : 1,
    renderCell: ({ row }) => (
      <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
        <CardMedia
          component="img"
          src={row.cover || row.artist_artwork || row.artist_profile}
          sx={{
            width: desktop ? 40 : 32,
            height: desktop ? 40 : 32,
            borderRadius: 1,
            flexShrink: 0,
          }}
        />
        <Typography
          variant="body2"
          noWrap
          sx={{ ml: 1.5, fontWeight: 600 }}
        >
          {row.title}
        </Typography>
      </Box>
    ),
  },
  {
    field: "play_count",
    headerName: "Plays",
    width: 100,
    type: "number",
    align: "left",
    headerAlign: "left",
  },
  {
    field: "listener_count",
    headerName: "Listeners",
    width: 80,
    type: "number",
    align: "left",
    headerAlign: "left",
  },
  {
    field: "writers",
    headerName: "Written by",
    width: 200,
    editable: true,
  },
  {
    field: "producers",
    headerName: "Produced by",
    width: 200,
    editable: true,
  },
  {
    field: "duration",
    headerName: "Duration",
    width: 90,
    type: "number",
    valueFormatter: (value) => formatSeconds(value),
  },
  {
    field: "live",
    headerName: "Live",
    width: 110,
    valueGetter: (_, row) => getIsodate(row.live),
  },
  {
    field: "expires",
    headerName: "Expired",
    width: 110,
    valueGetter: (_, row) =>
      row.expires < Date.now() / 1000 ? getIsodate(row.expires) : "",
  },
  {
    field: "deleted",
    headerName: "Archived",
    width: 110,
    valueGetter: (_, row) => (row.deleted ? getIsodate(row.deleted) : ""),
  },
  {
    field: "daysOnNotebook",
    headerName: "Days on Notebook",
    width: 130,
    type: "number",
    align: "left",
    headerAlign: "left",
    valueGetter: (_, row) => getDaysOnNotebook(row),
  },
];
